import React, {Fragment} from "react";
import {STATO_COMPLETO} from "../../../utility/common";
import {Link} from "react-router-dom";

export default function MenuQuote({
                                      user,
                                      isRuoloSocio,
                                      showMessage,
                                      infoPagamento,
                                  }) {

    return isRuoloSocio() && user &&
        <Fragment>
            {
                user.stato == STATO_COMPLETO ?
                    <Fragment>
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page"
                                  to="/list-quote">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-shopping-bag"/> Le tue
                                    quote
                                </div>
                            </Link>
                        </li>
                    </Fragment>
                    :
                    <Fragment>
                        {/*
                          Utente non valido
                          */
                        }
                        <li className="nav-item">
                            <button type={"button"}
                                    className="nav-link nav-link-btn"
                                    aria-current="page"
                                    onClick={() => {
                                        showMessage("Le tue quote", "In questa pagina potrai consultare lo stato e la scadenza delle tue quote, non appena la tua richiesta di adesione verrà approvata.");
                                    }}>
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-shopping-bag"/> Le tue
                                    quote
                                </div>
                            </button>
                        </li>
                    </Fragment>
            }
            {
                user.stato == STATO_COMPLETO &&
                <Fragment>
                    {
                        infoPagamento && infoPagamento.length > 0 &&
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page"
                                  to="/pagamenti">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-credit-card"/> Pagamenti
                                </div>
                            </Link>
                        </li>
                    }
                </Fragment>
            }
        </Fragment>
}